import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';

const OPBusinessConfig = initConst<IBusinessConfigs>(() => ({
  OPOrgPersLok: {
    defaultColumns: [
      { attributeDef: 'Namn', caption: 'Namn', header: true },
      { attributeDef: 'OrgNrPersNr', caption: 'Org.nr/Pers.nr' },
      { attributeDef: 'AdressRad', caption: 'Adress' },
      { attributeDef: 'Adress.TELEFON1', caption: 'Telefon' },
      { attributeDef: 'TypNamn', caption: 'Typ' },
    ],
    attributes: {
      Namn: {
        tableMinWidth: 150,
      },
    },
  },
  OPTvist: {
    defaultColumns: [
      { attributeDef: 'PERS_NR', caption: 'Personnummer' },
      { attributeDef: 'TVIST_KREM', caption: 'Tvist om krem.' },
      { attributeDef: 'TVIST_GRAVS', caption: 'Tvist om gravs.' },
    ],
  },
  OPKontakt: {
    defaultColumns: [{ attributeDef: 'NAMN', caption: 'Namn' }],
  },
}));

export default OPBusinessConfig;
